import React from "react"
import PropTypes from "prop-types"
import DoughnutChartAtom from "views/atoms/charts/doughnuts/DoughnutChartAtom"
import { cutLabel } from "views/atoms/text/cutLabel"

const EMPTY_DATA = {
  doughnut_charts: [],
  doughnut_charts_data_total: { number: 0, unit: "" },
}

// Doughnut that displays API labels as-is (provider, country, DC name).
const RawLabelDoughnutChartAtom = ({ chartData = EMPTY_DATA, unitType, title }) => {
  if (!chartData?.doughnut_charts?.length) return null

  const data = {
    doughnut_charts_data_total: chartData.doughnut_charts_data_total,
    doughnut_charts: chartData.doughnut_charts.map(({ data: value, label }) => ({
      data: value,
      label: cutLabel(label || "unknown", 28, 28),
    })),
  }

  return (
    <DoughnutChartAtom title={title} data={data} unitType={unitType} large />
  )
}

RawLabelDoughnutChartAtom.propTypes = {
  chartData: PropTypes.object,
  unitType: PropTypes.string,
  title: PropTypes.string,
}

RawLabelDoughnutChartAtom.defaultProps = {
  chartData: EMPTY_DATA,
  unitType: "count",
  title: "",
}

export default RawLabelDoughnutChartAtom
